import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m40 46 10 38 28-14zM160 46l-10 38-28-14z" }, null, -1),
    _createElementVNode("path", { d: "M50 80q10-20 50-20t50 20q10 30-20 50l-14 30-16-20-16 20-14-30q-30-20-20-50" }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mc-avatar)",
      d: "M64 92h20l-10 16zM116 92h20l-10 16z"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "100",
      cy: "130",
      fill: "var(--mc-avatar)",
      rx: "10",
      ry: "6"
    }, null, -1)
  ]))]))
}
export default { render: render }